import { NameValuePair } from "@zickko/shared";
import { onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { DocumentRepo } from "../repo/DocumentRepo";
import { toastStore } from "../utils/toastStore";
import { useDeepDeps } from "../utils/useDeepDeps";

/**
 *
 * @param documentRepo
 * @param key
 * @returns ReturnType - It cannot have update or refresh methods because to update a bound value it to save a new value to firestore
 */
type Return<T> = {
  value: T | undefined | null;
};
export const useDocumentBind = <K extends NameValuePair<string>, T>(
  documentRepo: DocumentRepo<K, T>,
  key: K
): Return<T> => {
  // * For bind use 3 states. undefined - loading, null - value not found, T - value loaded
  const [value, setValue] = useState<T | undefined | null>(undefined);

  useEffect(() => {
    //
    // if (!key) {
    //   setValue(undefined);
    //   return;
    // }

    const disposer = onSnapshot(
      documentRepo.ref(key),
      (snap) => {
        console.debug(`[bind] On snapshot listener:`, documentRepo.path(key), snap);
        if (snap.exists()) {
          setValue(snap.data() as T);
          return;
        }
        setValue(null);
        return;
      },
      (error) => {
        console.error(`${documentRepo.path(key)}`, error);
        toastStore.error(error.message);
        setValue(null);
      }
    );

    return () => {
      console.log(`Unsubscribing `, key);
      disposer();
    };
  }, useDeepDeps([key]));

  return { value };
};
